<template>
  <div class="v-table-wrapper-header">
    <div
      :style="{width: commonWidth + 'px', paddingRight: scrollWidth + 'px'}"
      class="v-table-wrapper-header-common">
      <v-data-table
        ref="tableCommon"
        class="v-table-wrapper-header-common-table"
        hide-default-footer
        hide-default-header
        :headers="headers"
        :items="[]"
      >
        <template v-slot:header="scope">
          <v-colgroup :state="'header common'" :scope="scope"></v-colgroup>

          <header-slot :multi-sort="multiSort" :type="'common'" :scope="scope">

            <template
              v-for="(_, slotKey) of $scopedSlots"
              v-slot:[slotKey]="scope"
            >
              <slot :name="slotKey" v-bind="scope"></slot>
            </template>

          </header-slot>
        </template>

        <template v-slot:body="scope">
          <tbody></tbody>
        </template>

      </v-data-table>
    </div>
    <div
      v-if="isFixed"
      :style="{width: fixedWidth + 'px', left: scrollLeftPX}"
      class="v-table-wrapper-header-fixed">
      <v-data-table
        class="v-table-wrapper-header-fixed-table"
        hide-default-footer
        hide-default-header
        :headers="fixedHeaders"
      >

        <template v-slot:header="scope">

          <v-colgroup :state="'header fixed'" :scope="scope"></v-colgroup>

          <header-slot :type="'fixed'" :scope="scope">

            <template
              v-for="(_, slotKey) of $scopedSlots"
              v-slot:[slotKey]="scope"
            >
              <slot :name="slotKey" v-bind="scope"></slot>
            </template>

          </header-slot>
        </template>

        <template v-slot:body="scope">
          <tbody></tbody>
        </template>

      </v-data-table>
    </div>
  </div>
</template>

<script>
  import VColgroup from './VColgroup'
  import HeaderSlot from './HeaderSlot'
  import { store } from '../store/'

  export default {
    name: 'TableWrapperHeader',
    components: {HeaderSlot, VColgroup},
    props: {
      multiSort: Boolean,
      isFixed: {
        type: Boolean,
        default: false
      },
      headers: Array,
      fixedHeaders: Array
    },
    computed: {
      commonWidth() {
        if (store.state.commonWidth) {
          return  store.state.commonWidth
        }
      },
      fixedWidth() {
        if (store.state.fixedWidth) {
          return  store.state.fixedWidth
        }
      },
      scrollLeft() {
        return store.state.scrollLeft
      },
      scrollLeftPX() {
        return Math.max(
          0,
          Math.min(
            store.state.scrollLeft,
            this.commonWidth - store.state.mainWidth
          )
        ) + 'px'
      },
      scrollWidth() {
        return store.state.scrollWidth
      }
    },
    methods: {
      setScrollWidth() {
        let div = document.createElement('div');

        div.classList.add('test-scroll-div');

        div.style.overflowY = 'scroll';
        div.style.width = '50px';
        div.style.height = '50px';

        document.body.append(div);

        const scrollWidth = div.offsetWidth - div.clientWidth;
        store.commit('setScrollWidth', scrollWidth)

        div.remove();
      }
    },
    watch: {
      scrollLeft(val) {
        this.$el.scrollLeft = val
      }
    },
    created() {
      this.setScrollWidth()
    },
    mounted() {
      store.commit('setHeaderHeight', this.$el.offsetHeight)
    }
  }
</script>

<style lang="scss" scoped>
  .v-table-wrapper-header {
    position: relative;
    z-index: 2;
    overflow-y: hidden;
    overflow-x: hidden;

    & .v-table-wrapper-header {
      overflow-y: auto;
    }

    &-common {
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
      overflow: hidden;
    }

    &-fixed {
      overflow: hidden;
      position: absolute;
      top: 0;
      height: 100%;
      z-index: 2;
      box-shadow: 10px 0px 10px -12px black;
    }
  }
</style>
